import { render, staticRenderFns } from "./productPrice.vue?vue&type=template&id=4d764af5&"
import script from "./productPrice.vue?vue&type=script&lang=js&"
export * from "./productPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports